import React from 'react';

interface ToggleProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label?: string;
}

export const Toggle: React.FC<ToggleProps> = ({ label, ...rest }) => {
  return (
    <label className="flex items-center justify-between gap-3 text-sm">
      {label && <span className="text-text">{label}</span>}
      <span className="relative inline-flex h-6 w-11 items-center">
        <input type="checkbox" className="peer sr-only" {...rest} />
        <span className="h-6 w-11 rounded-full bg-surfaceMuted transition-colors peer-checked:bg-brandLilac" />
        <span className="absolute left-1 h-4 w-4 rounded-full border border-borderSoft bg-white shadow-sm transition-transform peer-checked:translate-x-5" />
      </span>
    </label>
  );
};

